module.exports = __webpack_public_path__ + "static/media/hraswo_sukrabar_su.92ca5d17.ogg";